import { NgModule } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import { AuxJasper , ParametroJasper} from "app/entidades/entidades";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";

@Component({
  selector: 'app-generar-polizas',
  templateUrl: "./generar-polizas.component.html",
  styleUrls: ['./generar-polizas.component.css'],
})
export class GenerarPolizasComponent implements OnInit { 
  public muestraMensaje = new MuestraMensaje();
  public auxJasper: AuxJasper;
  public display: boolean = false;
  public progressBar: boolean = false;
  public formPolizaGroup: FormGroup;

 
  constructor( private formBuilder: FormBuilder) {}
   
   ngOnInit(): void {

    //const today = new Date();
    //this.fechaInicio = new Date(today.toISOString().slice(0, 10));
    //this.fechaFin = new Date(today.toISOString().slice(0, 10));
    
    this.formPolizaGroup = this.formBuilder.group({
      fechaCobro: [''],
      noImportada: [''],
      serie: [''],
      numPoliza: ['']

    });

   }

   showDialog() {
    this.display = false;
  }

   generaPoliza(){
    
    try {
 
      if (this.formPolizaGroup.value.fechaCobro == '' || this.formPolizaGroup.value.noImportada == '' || this.formPolizaGroup.value.serie == '' || this.formPolizaGroup.value.numPoliza == '') {
        throw new ValidacionException("Debe De Ingresar Todos Los Campos");
      }
     
      let fechaCobro = this.formPolizaGroup.value.fechaCobro;
      //cambio de formato de fecha "2021-09-01" a "01-09-2021"
      let fechaArray = fechaCobro.split("-");

      let fechacobroFormato = fechaArray[2] + "-" + fechaArray[1] + "-" + fechaArray[0];

      this.progressBar = true;
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "Poliza_contable";  //falta de sarrollar el reporte
      this.auxJasper.JasperReport.tipo = "csv";
      this.auxJasper.JasperReport.imprimir = true;
  
      let _fecha_cobro = new ParametroJasper();
      _fecha_cobro.nombre = "fecha_cobro";
      _fecha_cobro.valor =fechacobroFormato;
  
      let _id_importar = new ParametroJasper();
      _id_importar.nombre = "id_importar";
      _id_importar.valor = this.formPolizaGroup.value.noImportada;

      let _serie = new ParametroJasper();
      _serie.nombre = "serie";
      _serie.valor = this.formPolizaGroup.value.serie;
      
      let _num_poliza = new ParametroJasper();
      _num_poliza.nombre = "num_poliza";
      _num_poliza.valor = this.formPolizaGroup.value.numPoliza;

      let _id_usuario = new ParametroJasper();
      _id_usuario.nombre = "id_usuario";
      _id_usuario.valor = "0";

      this.auxJasper.ParametroJasper.push(_fecha_cobro);
      this.auxJasper.ParametroJasper.push(_id_importar);
      this.auxJasper.ParametroJasper.push(_serie);
      this.auxJasper.ParametroJasper.push(_num_poliza);
      this.auxJasper.ParametroJasper.push(_id_usuario);
      
      this.showDialog();
      
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");

    } catch (e) {

      this.progressBar = false;

      // Manejo de excepciones personalizadas
      if (e instanceof ValidacionException) {
        console.error("Ocurrió un error inesperado:", e);
        
      } else {
        // Muestra un mensaje de alerta al usuario
        this.muestraMensaje.error(e.message, "top", "center");
        console.error("Error de validación:", e.message);
      }
    }finally{
      this.progressBar = false; 
    }
    
  }
}


class ValidacionException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ValidacionException";
  }
}